/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_TvsInputs */

const he_home_category_tvs = /** @type {(inputs: Home_Category_TvsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טלוויזיות`)
};

const en_home_category_tvs = /** @type {(inputs: Home_Category_TvsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TVs`)
};

/**
* | output |
* | --- |
* | "TVs" |
*
* @param {Home_Category_TvsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_tvs = /** @type {((inputs?: Home_Category_TvsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_TvsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_tvs(inputs)
	return en_home_category_tvs(inputs)
});